import type { DocumentEmailHistoryType } from '@econtractor/types';
import TableEmptyRow from 'components/others/TableEmptyRow';
import EmailHistoryTableRow from './EmailHistoryTableRow';

interface EmailHistoryTableBodyProps {
    rows: DocumentEmailHistoryType[];
}

const EmailHistoryTableBody = ({ rows }: EmailHistoryTableBodyProps) => (
    <tbody>
        {rows.length ? rows.map((row) => <EmailHistoryTableRow key={row.ID} row={row} />) : <TableEmptyRow colSpan={4} />}
    </tbody>
);

export default EmailHistoryTableBody;
